module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/3@2x_a4a05c5b30fd1d4a352b80c13ac0163a.png";